<div class="page-container">
    <div class="row center-xs">
        <div class="col-xs-12 col-sm-11 col-md-9">
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h1>BOTON WEB</h1>
                            <div class="text-content-bigger">El comercio puede conectarse con nuestra librería web en
                                menos de 2 horas.
                                La librería web es full javascript, permitiendo la integración de cualquier tienda web
                                en cualquier lenguaje de programación.
                            </div>
                            <div class="text-content-bigger">El formulario de pago se crea dinámicamente, haciendo
                                segura la captura y el envío de los datos de tarjeta.
                                El comercio decide cómo y dónde mostrar el formulario de pago, permitiendo continuar con
                                la experiencia del cliente en la tienda web.
                            </div>
                            <!-- <div class="text-content-bigger">El pago es solicitado al procesador de pagos y la respuesta
                                es mostrada al cliente sin errores y sin demoras.
                                El comercio recibe la notificación de autorización de los servidores de epago.
                            </div> -->
                            <!-- <div class="text-content-bigger">Descarga un ejemplo de integración completo al botón de
                                pago web, <a href="https://github.com/synapsolutions/shop-web">visita nuestro link en
                                    git.</a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="img-container">
                        <img class="img" src="assets/img/web-cards-button-form.png">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h2>Instalación</h2>
                            <div class="text-content">La librería web es full javascript, permitiendo la integración de
                                cualquier tienda web en cualquier lenguaje de programación.
                            </div>
                            <div class="text-content">1. Importar libreria en la web
                            </div>
                            <div class="code-content-xs">
                                <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
                                    style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="57ba6cb170135dfb487ba87bff0f05b8"
                                    fileName="epago-web-head-script.html"></ng-gist>
                            </div>
                        </div>
                        <div class="paragraph">
                            <h2>Configuración</h2>
                            <div class="text-content">1. Cree el contenedor donde se visualizará el botón de pago web.
                            </div>
                            <div class="code-content-sm">
                                <!--<iframe src="https://pastebin.com/embed_iframe/CJAkGSYN"
                                    style="border:none;width:100%;height:100px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="21747c6572bf86c8d546928771aae93a"
                                    fileName="epago-web-body-div.html"></ng-gist>
                            </div>
                            <aside class="note"><b>Nota:</b> Las dimensiones de este contenedor deben ser de 370px de
                                ancho por 590px de alto.
                            </aside>
                            <div class="text-content">2. Inicialice y configure el formulario de pago (visualmente, el
                                ambiente de procesamiento de pago y la gestión visual de la respuesta).
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/1rTuStSk"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="40b41e8e1cfa094d0a3368678d0f7679"
                                fileName="epago-web-func-cards-startpayment.js"></ng-gist>
                            </div>
                            <aside class="note">
                                <b>Nota:</b> El mensaje de "Denegación" del procesador se obtiene:<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Código:</b> response.data.result.processorResult.code<br>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Mensaje:</b> response.data.result.processorResult.message<br>
                                <b>Nota 2:</b> Para revisar el detalle del mensaje de respuesta diríjase a la sección de <a routerLink="/api-events">"API de Eventos"</a><br>
                            </aside>
                            <div class="text-content">3. Setee los datos de la orden o pedido.
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/vx78zaBe"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="78c743959ea41fb1870315351879f1c4"
                                    fileName="epago-web-func-cards-buildTransaction.js"></ng-gist>
                                </div>
                            <div class="text-content">4. Setee los datos de autenticación.
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/T9xYvXHR"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="fb766bc7d3a4b8974dada53db86db1d0"
                                    fileName="epago-web-func-buildAuthentication.js"></ng-gist>
                            </div>
                            <aside class="note"><b>Nota:</b> El APIKey y SignatureKey están disponibles en la plataforma
                                de gestión de epago
                            </aside>
                            <div class="text-content">5. Las siguientes funciones son utilitarias y deben ser
                                utilizadas solo como "referencia".
                            </div>
                            <div class="code-content-md">
                                <!--<iframe src="https://pastebin.com/embed_iframe/VPfbEaw1"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="3d76955325c2cce5e90f7e7d3fcfdc28"
                                    fileName="epago-web-func-utilities.js"></ng-gist>
                            </div>
                        </div>
                        <div class="paragraph">
                            <h2>Estilos</h2>
                            <div class="text-content">1. Personalize el color del botón de pago en su hoja de estilo.
                            </div>
                            <div class="code-content-sm">
                                <!--<iframe src="https://pastebin.com/embed_iframe/CJAkGSYN"
                                    style="border:none;width:100%;height:100px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="dd2b666c0c16a16698c0ec7c9c4d171b"
                                    fileName="epago-web-css-cards-button.css"></ng-gist>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>